/**
 * Tokens neutros do redesign (projeto Claude Design "Medclinic Web").
 *
 * Só cinzas de layout e superfícies moram aqui. A cor de destaque NÃO entra
 * nesta tabela: ela vem sempre de `var(--primary-color)`, que muda entre as
 * marcas Follow e MedClinic. Cores semânticas de status vêm de
 * `@/constants/appointmentStatus`.
 */
export const TOKENS = {
	/** Fundo da área de conteúdo, atrás dos cards */
	appBg: '#f4f6f8',
	/** Superfície de card / barra / painel */
	surface: '#ffffff',
	/** Trilho cinza atrás de segmented controls */
	track: '#f2f4f6',

	/** Borda padrão de card e painel */
	border: '#e8ebee',
	/** Borda de controle (input, select, botão de toolbar) — um passo mais escura */
	borderControl: '#dfe3e7',
	/** Linha divisória entre itens de lista */
	divider: '#f0f2f4',

	/** Texto principal */
	text: '#1f2937',
	/** Título de seção / rótulo de campo */
	textStrong: '#2b3439',
	/** Texto de corpo em controles */
	textBody: '#3f4a53',
	/** Texto secundário (valores de tabela, legendas) */
	textMuted: '#59636b',
	/** Texto de apoio (subtítulo de tela, metadados) */
	textSubtle: '#7b858d',
	/** Texto fraco (datas, contadores) */
	textFaint: '#8a939a',
	/** Placeholder e ícones inativos */
	textPlaceholder: '#9aa3ab',

	/** Ponto de notificação / contador de pendências */
	danger: '#e5484d',

	/** Sombra de card elevado (menu, popover) */
	shadowPopover: '0 14px 38px rgba(16, 24, 40, 0.2)',
	/** Sombra do estado ativo do segmented control */
	shadowRaised: '0 1px 2px rgba(16, 24, 40, 0.08)',

	/** Raio padrão de card */
	radiusCard: '10px',
	/** Raio padrão de controle */
	radiusControl: '6px'
} as const;

/** Largura do trilho de ícones da sidebar, em px. */
export const RAIL_WIDTH = 64;

/** Altura da barra superior, em px. */
export const TOPBAR_HEIGHT = 56;
